import React from "react";
import { HomeSection } from "./HomeSection";
import { Box, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { InteractiveCatalog } from "../interactives/InteractiveCatalog";

export function InteractivesSection() {
  return (
    <HomeSection
      id="interactives"
      title="Interactives"
      description="Small experiments to explore, play with, and make your own."
    >
      <InteractiveCatalog limit={6} />
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Button
          component={Link}
          to="/interactives"
          variant="outlined"
          size="large"
        >
          View all interactives
        </Button>
      </Box>
    </HomeSection>
  );
}
